import { TextField } from '../../ui';
import { useT } from '../../i18n/i18n.tsx';

/**
 * DESIGN.md §9.3 [Requests] `SingerNameField` — prefilled from `localStorage` (AC-REQ-4), capped
 * at 40 characters to match the server's own `singerName` field (song-request schema.json) so a
 * guest sees the real limit instead of learning it from a 400 after they submit.
 */
export function SingerNameField({
  value,
  onChange,
  autoFocus,
}: {
  value: string;
  onChange: (value: string) => void;
  autoFocus?: boolean;
}) {
  const t = useT();
  return (
    <TextField
      label={t('guest.singerName.label')}
      placeholder={t('guest.singerName.placeholder')}
      value={value}
      onChange={(e) => onChange(e.currentTarget.value)}
      maxLength={40}
      autoFocus={autoFocus}
      autoComplete="off"
      required
    />
  );
}
